import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BFFHttpError } from '../model/BFFHttpError';

export const useUsidGet = (): UseQueryResult<string | null> => {
    const authContext = useAuthContext();

    // eslint-disable-next-line @tanstack/query/prefer-query-object-syntax
    return useQuery<string | null, BFFHttpError>({
        queryFn: async (): Promise<string | null> => {
            if (!isServer) await window.sfccSessionCreationPromise;
            return authContext.ready().then((data) => data.usid ?? null);
        },
        queryKey: [BffQueryKey.USID],
        initialData: null,
        enabled: !isServer,
        refetchOnWindowFocus: false,
    } as UseQueryOptions<string | null, BFFHttpError>);
};
